import React, { ReactNode, Fragment } from "react";

type Props = {
  children: ReactNode;
};

export const MultiLineText: React.VFC<Props> = ({ children }) => {
  if (typeof children === "string") {
    return (
      <Fragment>
        {children.split("\n").map((i, key) => {
          return (
            <span key={`multiline_${i}_${key}`}>
              {i}
              <br />
            </span>
          );
        })}
      </Fragment>
    );
  } else {
    return <Fragment>{children}</Fragment>;
  }
};
